import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";
import { t } from "../lib/i18n";

const KEY = "relevo_cookie_consent";

export const getCookieConsent = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch { return null; }
};

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getCookieConsent()) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-md z-50 hairline bg-[#1E3A5F] text-bone p-5 shadow-2xl fade-up"
      role="dialog"
      aria-live="polite"
      aria-label={t("Aviso de cookies")}
      data-testid="cookie-banner"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center bg-white/10">
          <Cookie className="w-4 h-4 text-[#E4B54B]" />
        </div>
        <div className="flex-1">
          <span className="font-mono-label text-gold">{t("Cookies")}</span>
          <p className="text-sm leading-relaxed mt-1 text-bone/90">
            {t("Usamos cookies necesarias para que Relevo funcione. Las analíticas solo se activan si las aceptas.")}{" "}
            <Link to="/cookies" className="underline underline-offset-2 hover:text-white" data-testid="cookie-banner-policy-link">
              {t("Política de Cookies")}
            </Link>
          </p>
          <div className="flex flex-wrap gap-2 mt-4">
            <Button
              onClick={() => decide("accepted")}
              className="rounded-none h-9 px-4 bg-[#E0712C] hover:bg-[#C25F1E] text-white"
              data-testid="cookie-accept-btn"
            >
              {t("Aceptar")}
            </Button>
            <Button
              onClick={() => decide("rejected")}
              variant="outline"
              className="rounded-none h-9 px-4 border-bone/40 text-bone bg-transparent hover:bg-white/10 hover:text-white"
              data-testid="cookie-reject-btn"
            >
              {t("Rechazar")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
